'use client';

import { Button, useModal } from '@payloadcms/ui';
import { BeforeListTableClientProps } from 'payload';

import CreateNewLandingModal, { CREATE_NEW_LANDING_MODAL_SLUG } from './CreateNewLandingModal/CreateNewLandingModal';

const CreateNewLandingButton = ({ hasCreatePermission }: BeforeListTableClientProps) => {
  const { openModal } = useModal();

  if (!hasCreatePermission) return;

  return (
    <>
      <Button
        onClick={() => openModal(CREATE_NEW_LANDING_MODAL_SLUG)}
        buttonStyle="primary"
        icon="plus"
        extraButtonProps={{ 'data-testid': 'create-new-landing-open' }}
      >
        Create new landing
      </Button>
      <CreateNewLandingModal />
    </>
  );
};

export default CreateNewLandingButton;
